
import React from 'react';

export const AuthHeader = () => {
  return (
    <div className="mb-8 text-center">
      <div className="flex items-center justify-center mb-4">
        <div className="relative w-16 h-16 flex items-center justify-center">
          <div className="absolute inset-0 bg-youtube-red rounded-full opacity-20 animate-pulse-glow"></div>
          <svg className="w-12 h-12 text-youtube-red relative z-10" viewBox="0 0 24 24" fill="currentColor">
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 12 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
          </svg>
        </div>
      </div>
      
      <div className="py-2 px-6 bg-white dark:bg-youtube-dark-accent rounded-full shadow-md inline-block mb-2 transform hover:scale-105 transition-all duration-300">
        <h1 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-youtube-red to-youtube-red-dark">
          PersonalTube Dashboard
        </h1>
      </div>
      
      <p className="text-gray-600 dark:text-gray-400 mt-2 font-light">Votre expérience YouTube personnalisée</p>
    </div>
  );
};
